<template>
  <div>
    <form-section
      :title="$t('CampaignForm_Schedule_Journey_Frequency_Section_Title')"
      :description="
        $t('CampaignForm_Schedule_Journey_Frequency_Section_Description')
      "
      :separator="true"
    >
      <journey-option-enter-once :model="model" />
      <journey-option-enter-once :once-ever="true" :model="model" />
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import JourneyOptionEnterOnce from '@/modules/campaign-manage/components/JourneyOptionEnterOnce.vue'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'

export default {
  name: 'JourneyOptions',
  data() {
    return {
      campaignTriggerTypes,
      campaignTypeEnum
    }
  },

  components: {
    FormSection,
    JourneyOptionEnterOnce
  },

  props: {
    model: {
      type: Object
    }
  }
}
</script>

<style scoped>
>>> div.label-ct {
  width: 310px !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/JourneyOptions.vue